module.exports = __webpack_public_path__ + "img/block_20241217.7c69027c.webp";